const state = {
    selectedTab: '',
    previousTab: '',

    ecoTaxiState: 'people',
};

const getters = {

    selectedTab(state) {
        return state.selectedTab;
    },

    previousTab(state) {
        return state.previousTab;
    },

    ecoTaxiState(state) {
        return state.ecoTaxiState;
    },
};

const actions = {

    async selectTab({commit, dispatch, getters, rootState}, tab) {
        if (state.selectedTab !== tab) {
            commit('setPreviousTab', state.selectedTab);
        }
        commit('setSelectedTab', tab);
    },
};

const mutations = {

    setSelectedTab(state, selectedTab) {
        state.selectedTab = selectedTab;
    },

    setPreviousTab(state, previousTab) {
        state.previousTab = previousTab;
    },

    setEcoTaxiState(state, ecoTaxiState) {
        state.ecoTaxiState = ecoTaxiState;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
